export enum EGroundTypes {
    COLOR = 0,
    TEXTURE = 1,
    GRASS = 2
}
